import { RG_TYPE } from "@project-rouge/rg-core";
import { getAncestorTypes } from "@project-rouge/rg-three";
var includedTypes = [...getAncestorTypes(RG_TYPE.Corridor), RG_TYPE.Corridor];
function getShallowRgObj(obj, shallow = getShallowObj(obj)) {
	for (const child of obj.children) {
		if (!includedTypes.includes(child.type)) continue;
		if (child.type === RG_TYPE.Corridor) {
			if (child.data.level !== 0) continue;
		}
		const shallowChild = getShallowObj(child);
		shallow.children.push(shallowChild);
		getShallowRgObj(child, shallowChild);
	}
	return shallow;
}
function getShallowObj(obj) {
	return {
		...obj,
		children: [],
		data: void 0,
		hash: void 0,
		templateUuid: void 0,
		uuid: "",
		parent: void 0
	};
}
export { getShallowRgObj };

//# sourceMappingURL=index235.js.map